// src/components/PrivateRoute.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isTokenExpired } from "../utils";
import { logout } from "../store/userSlice";

// Function to check if token is expired

const PrivateRoute = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { token, isAuthenticated } = useSelector((state) => state.user);
  const refreshToken = localStorage.getItem("refresh_token");

  useEffect(() => {
    // Check token status on route change or mount
    if (token && isTokenExpired(token) && !refreshToken) {
      dispatch(logout());
    }
  }, [token, dispatch, location.pathname]);

  // Redirect to login if not authenticated
  if (!isAuthenticated || !token || (isTokenExpired(token) && !refreshToken)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
